/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentTerms
 */
export interface PaymentTerms {
    /**
     * 
     * @type {string}
     * @memberof PaymentTerms
     */
    id?: string;
}

/**
 * Check if a given object implements the PaymentTerms interface.
 */
export function instanceOfPaymentTerms(value: object): boolean {
    return true;
}

export function PaymentTermsFromJSON(json: any): PaymentTerms {
    return PaymentTermsFromJSONTyped(json, false);
}

export function PaymentTermsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentTerms {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
    };
}

export function PaymentTermsToJSON(value?: PaymentTerms | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
    };
}

